import { Typography } from "antd";
import { FormattedMessage } from "react-intl";

import Product from "./product";

const productCodes = ["ECD_B2B", "ECD_B2C", "ECI", "ERI"];

const hasProduct = (products, idx) =>
  products.some((p) => p === productCodes[idx]);

const addProduct = (hasProduct, products, idx) =>
  hasProduct && products.push(productCodes[idx]);

export const parseProductsForm = (values) => {
  const products = [];
  addProduct(values.productEcdB2b, products, 0);
  addProduct(values.productEcdB2c, products, 1);
  addProduct(values.productEci, products, 2);
  addProduct(values.productEri, products, 3);
  return products;
};

export const parseInitialProductForm = (products) => {
  const values = {};
  if (products) {
    values.productEcdB2b = hasProduct(products, 0);
    values.productEcdB2c = hasProduct(products, 1);
    values.productEci = hasProduct(products, 2);
    values.productEri = hasProduct(products, 3);
  }
  return values;
};

export const validateProducts = (values) =>
  parseProductsForm(values).length > 0;

const Products = ({ hasError, formItemLayout }) => (
  <>
    <Product
      countOfItems={8}
      fieldName="productEcdB2b"
      labelDefaultMessage="DHL Freight EuroConnect Domestic"
      formItemLayout={formItemLayout}
      labelId="registration.products.ecdb2b"
      textId="registration.products.ecdb2b.text"
      infoTextId="registration.products.ecdb2b.info"
      infoTextDefaultMessage="Firemní paleta / LTL přepravy"
      textDefaultMessage="Vnitrostátní paletová přeprava kusových zásilek nabízí vynikající kvalitu, vysokou spolehlivost a nákladově efektivní doručení door-to-door."
    />
    <Product
      countOfItems={8}
      fieldName="productEcdB2c"
      labelDefaultMessage="DHL Freight Home Delivery Domestic"
      formItemLayout={formItemLayout}
      labelId="registration.products.ecdb2c"
      textId="registration.products.ecdb2c.text"
      infoTextId="registration.products.ecdb2c.info"
      infoTextDefaultMessage="Soukromá paleta / LTL přepravy"
      textDefaultMessage="Vnitrostátní paletová přeprava kusových zásilek nabízí vynikající kvalitu, vysokou spolehlivost a nákladově efektivní doručení door-to-door."
    />
    <Product
      last
      countOfItems={9}
      fieldName="productEci"
      labelDefaultMessage="DHL Freight EuroConnect International"
      formItemLayout={formItemLayout}
      labelId="registration.products.eci"
      textId="registration.products.eci.text"
      infoTextId="registration.products.eci.info"
      infoTextDefaultMessage="Spolehlivé a nákladově efektivní LTL přepravy"
      textDefaultMessage="Náš síťový produkt Less-than-Truck-Load (LTL) pro paletizované a nepaletizované sběrné zásilky nabízí vynikající kvalitu, vysoce spolehlivá, nákladově efektivní door-to-door spojení po celé Evropě."
    />
    {/* <Product
      countOfItems={9}
      fieldName="productEri"
      labelDefaultMessage="DHL Freight Eurapid"
      formItemLayout={formItemLayout}
      labelId="registration.products.eri"
      textId="registration.products.eri.text"
      infoTextId="registration.products.eri.info"
      infoTextDefaultMessage="LTL přepravy s možností definice dne nakládky a doručení"
      textDefaultMessage="Naše celoevropské prioritní služby door-to-door s definovanými dny pro paletizované a nepaletizované sběrné zásilky, včetně kvalitního zákaznického servisu."
    /> */}
    {hasError && (
      <Typography.Text type="danger">
        <FormattedMessage
          id="registration.products.warn"
          defaultMessage="Musíte vybrat alespoň jeden produkt!"
        />
      </Typography.Text>
    )}
  </>
);

export default Products;
